/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2023-11-14 17:49:21
 * @LastEditors: caiqin.xie
 * @message: 服务主页
 * @url: www.picoxr.com/cn/support
 */

import React, {useState} from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import Banner from "./components/Banner";
import ServiceRecommendation from "./components/ServiceRecommendation";
import ProductSupport from "./components/ProductSupport";
import ServiceCenter from "./components/ServiceCenter";
import ContactUs from "./components/ContactUs";
import styles from "./index.module.scss";
import request from '@/common/request'
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST, SUPPORTPOS, SUPPORTSECONDPOS } from '@/common/const'


const Support = (props: any) => {
  let { ctry, words, data, data:{bannerList, bannerListSecond, areas, products} } = props.data
  const [serviceShop, setServiceShop] = useState<any>(data?.serviceShop || null) // 服务门店
  const contactData = data?.bContact || null // 联系我们
  console.log(data?.bContact)
  // 搜索服务门店
  const getList = (query:any) => {
    console.log(query)
    request.post(`${DOMAIN_API}/o/official/shop/list`, {
      manageType: '0',//管理类型 0-服务门店 1-零售门店
      rows:10,
      page:1,
      ...query,
      stationCode: ctry
    })
      .then(res => {
        let { records } = res.data
        setServiceShop(records?.length > 0 ? records[0] : null )
        console.log(serviceShop)
    })
    .catch(err => {
      console.log(err)
    })
  }
  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support`} />
      ))
    )
  }

  return (
    <div>
      <Helmet>
        <title>{words?.support_seo_title}</title>
        <meta name="description" content={words?.support_seo_description} />
        <meta name="keywords" content={words?.support_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['support-wrap']}>
        {/* banner区 */}
        <Banner ctry={ctry} words={words} bannerList={bannerList} />

        {/* 内容区 */}
        <div className={styles["support-content"]}>
          {/* 服务推荐 */}
          <ServiceRecommendation ctry={ctry} words={words} banner={bannerListSecond[0]} />

          {/* 产品支持 */}
          <ProductSupport ctry={ctry} words={words} productList={products} />

          {/* 门店信息 */}
          <ServiceCenter ctry={ctry} words={words} shop={serviceShop} areaList={areas} getList={ (query)=>getList(query) } />

          {/* 联系我们 */}
          <ContactUs ctry={ctry} words={words} contactData={contactData} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/official/support/getSupportGather`, {
      stationCode: ctry,
      bannerPositionId: SUPPORTPOS,
      bannerPositionIdSecond: SUPPORTSECONDPOS
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

Support.getInitialProps = (ctry: string) => {
  return getInit(ctry)
};
export default Support;
